export function validatePasswordChange(security) {
  if (!security.currentPassword?.trim()) {
    return 'Inserisci la password attuale!';
  }

  if (security.newPassword !== security.confirmPassword) {
    return 'Le password non coincidono!';
  }

  if (security.newPassword.length < 8) {
    return 'La password deve essere di almeno 8 caratteri!';
  }

  return '';
}
